import {
    Flex,
    Text,
    useColorModeValue
} from "@chakra-ui/react";
import CardHeader from "components/Card/CardHeader";

function ListPageCardHeader(props) {
    const { title, subtitle, ...rest } = props;
    const titleColor = useColorModeValue("gray.700", "white");
    const subColor = useColorModeValue("gray.500", "gray.400");
    const borderColor = useColorModeValue("#EDF2F7", "#E2E8F0"); //gray-100 e gray-200

    return (
        <CardHeader px="22px" mb="24px" {...rest} border={`solid 0.1em ${borderColor}`} borderRadius='lg' padding="1em">
            <Flex gap="1" direction="column">
                <Text color={titleColor} fontSize="lg" fontWeight="bold">
                    {title}
                </Text>
                <Text color={subColor} fontSize="sm" fontWeight="normal">
                    {subtitle}
                </Text>
            </Flex>
        </CardHeader>
    );
}

export default ListPageCardHeader;
